var _style, _path, _defs, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 1027.9 315.4",
    style: {
      enableBackground: "new 0 0 1027.9 315.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#fff}.st2,.st3{clip-path:url(#SVGID_2_);fill:#ecbb13}.st3{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "logo_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "main",
    d: "M130 137.3c-7.2 0-14 1.9-19.9 5.3l-19.7-19.7c2.3-5.1 3.6-10.7 3.6-16.6 0-22.1-17.9-40-40-40s-40 17.9-40 40 17.9 40 40 40c8.9 0 17-2.9 23.7-7.8l18.1 18.1c-3.7 6-5.8 13.1-5.8 20.7 0 7.7 2.2 14.8 5.9 20.9l-16.2 16.2c-6.9-5.7-15.8-9.1-25.4-9.1-22.1 0-40 17.9-40 40 0 13.7 6.9 25.8 17.4 33l22.6 22.6 22.6-22.6c10.5-7.2 17.4-19.3 17.4-33 0-5.1-1-10-2.7-14.5l18.7-18.7c5.8 3.3 12.5 5.2 19.7 5.2 22.1 0 40-17.9 40-40s-17.9-40-40-40zm-76-11c-11 0-20-9-20-20s9-20 20-20 20 9 20 20-9 20-20 20zm.3 99c11 0 20 9 20 20s-9 20-20 20-20-9-20-20 9-20 20-20zm75.7-28c-11 0-20-9-20-20s9-20 20-20 20 9 20 20-9 20-20 20z",
    style: {
      fill: "#ecbb13"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dot_1_",
    className: "st1",
    d: "M54.7 234.3c-6.3 0-11.3 5.1-11.3 11.3s5 11.4 11.3 11.4S66 251.9 66 245.7s-5.1-11.4-11.3-11.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "letters"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M10 148h1010.9v153.4H10z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "i",
    className: "st2",
    d: "M823.8 193h28v108h-28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "o",
    className: "st2",
    d: "M940 301.2c-40.8 0-74-34.3-74-76.5s33.2-76.5 74-76.5 74 34.3 74 76.5c0 42.1-33.2 76.5-74 76.5zm0-125c-25.4 0-46 21.8-46 48.5s20.6 48.5 46 48.5 46-21.8 46-48.5-20.6-48.5-46-48.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "i_.",
    className: "st2",
    d: "M823.8 133h28v45h-28z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "dot",
    className: "st3",
    d: "M800.7 280.3c-6.3 0-11.3 5.1-11.3 11.3s5.1 11.3 11.3 11.3c6.3 0 11.3-5.1 11.3-11.3s-5.1-11.3-11.3-11.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "q",
    className: "st3",
    d: "m778.4 302.2-21.9-24.7c12.7-13.7 20.5-32.3 20.5-52.8 0-42.2-33.2-76.5-74-76.5s-74 34.3-74 76.5 33.2 76.5 74 76.5c11 0 21.5-2.5 30.9-7l23.6 26.6 20.9-18.6zM657 224.7c0-26.7 20.6-48.5 46-48.5s46 21.8 46 48.5-20.6 48.5-46 48.5-46-21.8-46-48.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "h",
    className: "st3",
    d: "M586.8 118v88h-62v-92h-28v187h28v-67h62v67h28V118z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "k_1_",
    className: "st3",
    d: "m508.2 120-20.4-19.2-114 121.1 6.9 6.4-.4.3L481 342.3l21-18.5-90-101.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "a",
    className: "st3",
    d: "M326.8 148v20c-13.2-12.4-30.6-20-49.8-20-40.8 0-74 34.3-74 76.5s33.2 76.5 74 76.5c19.2 0 36.7-7.6 49.8-20v20h28V148h-28zM277 273c-25.4 0-46-21.8-46-48.5s20.6-48.5 46-48.5 46 21.8 46 48.5-20.6 48.5-46 48.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "k",
    className: "st1",
    d: "M368.8 14h28v287h-28z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ba7c128db2ff905fdb6f490c185d2470.svg";
export { ForwardRef as ReactComponent };